<template>
  <header class="header">
    <div class="header-nav" v-if="!back">
      <a href="#" @click.prevent="scrollTo('como-funciona')" class="link">Como funciona?</a>
    </div>
    <div class="header-nav" v-else>
      <a href="#" @click.prevent="$router.go(-1)" class="link">Back</a>
    </div>
    <slot />
  </header>
</template>

<script>
export default {
  name: 'header-nav',
  props: {
    back: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    scrollTo(id) {
      const scrollY = document.getElementById(id).offsetTop - 24;
      window.$scrollTo(scrollY)
    }
  }
};
</script>

<style lang="scss" scoped>
  .header {
    position: relative;
    height: 90vh;
    color: white;
    background: url(./../assets/img/bg-header-face.jpg) center center #525e69;
    background-size: cover;
    .header-nav {
      display: flex;
      justify-content: space-between;
      position: relative;
      z-index: 1;
      .link {
        color: white;
        text-decoration: none;
        text-transform: uppercase;
        padding: 10px;
        margin: 22px;
        letter-spacing: 2px;
        text-indent: 2px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderNav.vue